import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './position-profile-notes.module.scss';
import { BasicTable } from '../../../assets/common';
import positionProfileApi from '../../../services/positionProfileApi';
import { Spin } from 'antd';
import moment from 'moment';

const PositionProfileNotes = ({ positionCode }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = useCallback(async () => {
    if (!positionCode) return;
    try {
      setLoading(true);
      const res = await positionProfileApi.getNotes(positionCode);
      if (res.status === 200) {
        setData(res.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [positionCode]);

  const COLUMNS = useMemo(
    () => [
      {
        title: 'Meeting Name',
        width: '30%',
        dataIndex: 'name',
        render: (value) => <span className={styles.text1}>{value || '-'}</span>,
      },
      {
        title: 'Date',
        width: '10%',
        dataIndex: 'start_at',
        render: (value) => <span className={styles.text}>{value ? moment(value).format('DD MMM YYYY') : '-'}</span>,
      },
      {
        title: 'Succession Planning Name',
        dataIndex: 'agenda_name',
        render: (value) => <span className={styles.text}>{value || '-'}</span>,
      },
      {
        title: 'Remarks',
        width: '30%',
        dataIndex: 'remarks',
        render: (value) => <span className={styles.text}>{value || '-'}</span>,
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Spin spinning={loading}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Notes</div>
        <div className={styles.tableContainer}>
          <BasicTable
            rowKey="id"
            styles={{
              headerColor: '#8896A7',
              headerWeight: 700,
              borderRadius: 6,
            }}
            dataSource={data}
            columns={COLUMNS}
            pagination={false}
          />
        </div>
      </div>
    </Spin>
  );
};

export default PositionProfileNotes;

PositionProfileNotes.propTypes = {
  positionCode: PropTypes.string,
};
